import { render, staticRenderFns } from "./AboutUsAdd.vue?vue&type=template&id=24f44833&scoped=true&"
import script from "./AboutUsAdd.vue?vue&type=script&lang=js&"
export * from "./AboutUsAdd.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsAdd.vue?vue&type=style&index=0&id=24f44833&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f44833",
  null
  
)

export default component.exports